module.exports = __webpack_public_path__ + "static/graphite-dd941018520811e487fd87eed73863f5.png";